import utilsApi from '../assets/js/utils';
export default utilsApi.creatApi({
    // 新建地址
    createAddressItem: ["post", "//router.gamersky.com/@/AddressMatchInfo/NewBuiltAddress"],

    // 获取地址列表
    getAddresList: ["post", "//router.gamersky.com/@/AddressMatchInfo/GetAddressList"],

    // 获取单个列表
    getAddresEdit: ["post", "//router.gamersky.com/@/AddressMatchInfo/GetAddressEdit"],

    // 更新地址
    updataAddress: ["post", "//router.gamersky.com/@/AddressMatchInfo/UpdateAddress"],
    // 删除地址
    deleteAddress: ["post", "//router.gamersky.com/@/AddressMatchInfo/DeleteAddress"],
    // 获取默认地址
    getChooseAddress: ["post", "//router.gamersky.com/@/AddressMatchInfo/GetChooseAddress"],

});